import { ReportsController } from './reports-controller';
import moment from 'moment';
import { compact, find, keys, map, uniq, values } from 'lodash';

export default class extends ReportsController {
  chartMap() {
    return Object.freeze({
      chart: 'line'
    })
  }

  datasets() {
    return this.chartModel.series.map((series, index) => {
      return {
        label: series,
        data: this.chartModel.data[index],
        fill: true,
        borderWidth: 2,
        tension: 0.4,
      }
    })
  }

  disconnect() {
    this.chart.destroy();
  }

  formatReportData() {
    let dates = [];
    let labels = [];
    let data = {};
    let rows = this.reportValue.data;
    let names = this.getNames(rows);
    let isSingleDay = this.chartModel.isSingleDay;

    this.setupDates(dates, labels);

    dates.forEach(function(date) {
      names.forEach(function(name) {
        let row = find(rows, function(d) {
          let dateField = isSingleDay ? d.completed_hour : d.completed_date;

          return d._type === 'data' && // eslint-disable-line no-underscore-dangle
            d.primary_text === name &&
            dateField === date;
        });

        this.addRow(data, name, row);
      }, this);
    }, this);

    return {
      labels: labels,
      series: keys(data),
      data: values(data)
    };
  }

  addRow(data, name, row) {
    data[name] = data[name] || [];

    if (row) {
      data[name].push(this.moneyToFloat(row.item_total));
    } else {
      data[name].push(0);
    }
  }

  getNames(data) {
    let destinationId = this.chartModel.destinationId;
    return uniq(compact(map(data, function(row) {
      if (row._type === 'data') { // eslint-disable-line no-underscore-dangle
        if (destinationId) {
          if (row.destination_id === destinationId) {
            return row.primary_text;
          }
        } else {
          return row.primary_text;
        }
      }
    }))).sort();
  }

  setupDates(dates, labels) {
    let start = this.startDate.clone().startOf('day');
    let end = this.endDate.clone().endOf('day');

    if (this.chartModel.isSingleDay) {
      let duration = 24;
      for (let hour = 0; duration > hour; hour++) {
        dates.push(moment(start).add(hour, 'hours').format('YYYY-MM-DD HH:mm'));
        labels.push(moment(start).add(hour, 'hours').format('h:mm a'));
      }
    } else {
      start.subtract(1, 'day');

      while (start.add(1, 'day').diff(end) < 0) {
        dates.push(start.format('YYYY-MM-DD'));
        labels.push(start.format('dd M/D'));
      }
    }
  }

  getTotalRow() {
    let totalRow = {
      item_total: 0,
      card_item_total: 0,
      cash_item_total: 0,
      tip_total: 0,
      room_charge_total: 0
    };
    let data = this.reportValue.data;

    if (!this.chartModel.destinationId) {
      let row = find(data, ['primary_text', 'Grand Total']);

      if (row) {
        totalRow.item_total = this.moneyToFloat(row.item_total);
        totalRow.card_item_total = this.moneyToFloat(row.card_item_total);
        totalRow.cash_item_total = this.moneyToFloat(row.cash_item_total);
        totalRow.tip_total = this.moneyToFloat(row.tip_total);
        totalRow.room_charge_total = this.moneyToFloat(row.room_charge_item_total);
      }

      return totalRow;
    }

    data.forEach(function(row) {
      if (row._type === 'data' && row.destination_id === this.chartModel.destinationId) { // eslint-disable-line no-underscore-dangle
        totalRow.item_total += this.moneyToFloat(row.item_total);
        totalRow.card_item_total += this.moneyToFloat(row.card_item_total);
        totalRow.cash_item_total += this.moneyToFloat(row.cash_item_total);
        totalRow.tip_total += this.moneyToFloat(row.tip_total);
        totalRow.room_charge_total += this.moneyToFloat(row.room_charge_item_total);
      }
    }, this);

    return totalRow;
  }

  getDefaultOptions() {
    return {
      aspectRatio: window.screen.width < 1025 ? 1 : 2,
    }
  }
}
